import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Manda el historial y devuelve { answer, steps, proposals }.
// El agente puede tardar: encadena varias consultas antes de responder.
export async function askAgent(messages) {
  // Generoso a propósito: si convoca especialistas son varios loops encadenados
  // contra el modelo, y cortar a los 2 minutos abortaba respuestas que venían bien.
  const { data } = await client.post('/agent', { messages }, { timeout: 240000 });
  return data;
}

// Aplica una propuesta que la persona confirmó.
export async function executeProposal({ tool, args }) {
  const { data } = await client.post('/agent/execute', { tool, args }, { timeout: 30000 });
  return data;
}

const agentService = { askAgent, executeProposal };
export default agentService;
